// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2dtmB","content":"LoadingAlert_content__FsJpy"};